/**
 * Returns the nearest ancestor of `el` that can scroll vertically.
 */
export function findVerticalScrollParent(el: HTMLElement): HTMLElement | null {
  let parent = el.parentElement;
  while (parent) {
    const { overflowY } = getComputedStyle(parent);
    if (
      (overflowY === 'auto' ||
        overflowY === 'scroll' ||
        overflowY === 'overlay') &&
      parent.scrollHeight > parent.clientHeight
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return null;
}

/**
 * Smooth-scrolls `target` into view inside its nearest scrollable ancestor
 * (e.g. a PrimeNG dialog body). Falls back to `scrollIntoView` on the
 * document when no scroll parent is found.
 */
export function smoothScrollIntoView(
  target: HTMLElement,
  options?: { block?: ScrollLogicalPosition }
): void {
  const scrollParent = findVerticalScrollParent(target);
  if (scrollParent) {
    const scrollMarginTop =
      Number.parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    const top =
      scrollParent.scrollTop +
      target.getBoundingClientRect().top -
      scrollParent.getBoundingClientRect().top -
      scrollMarginTop;
    scrollParent.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    return;
  }
  target.scrollIntoView({
    behavior: 'smooth',
    block: options?.block ?? 'start',
  });
}
